

import { createSlice } from '@reduxjs/toolkit';

export interface LangSliceState {
    lang: string;
}

const langSlice = createSlice({
    name: 'lang',
    initialState: {
        lang: '',
    },
    reducers: {
        setAppLang: (state, action) => {
            state.lang = action.payload;
        },
    },
});

export default langSlice;
export const { setAppLang } = langSlice.actions;
export const selectLang = (state: any): LangSliceState => state.lang.lang;


import { createSlice } from '@reduxjs/toolkit';

export interface LangSliceState {
    lang: string;
}

const langSlice = createSlice({
    name: 'lang',
    initialState: {
        lang: '',
    },
    reducers: {
        setAppLang: (state, action) => {
            state.lang = action.payload;
        },
    },
});

export default langSlice;
export const { setAppLang } = langSlice.actions;
export const selectLang = (state: any): LangSliceState => state.lang.lang;
